export const buildIconCircleStyle = (size) => ({
  backgroundColor: "var(--goa-color-greyscale-100, #f1f1f1)",
  borderRadius: "50%",
  width: size,
  height: size,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});